import React from "react";
import PropTypes from "prop-types";

import css from "./LoadingIndicator.module.scss";

/* eslint-disable react/forbid-prop-types */

const LoadingIndicator = ({ colour = "light", size = "small", style = {} }) => {
  let sizeClass = css.sizeSmall;
  if (size === "large") {
    sizeClass = css.sizeLarge;
  }
  return (
    <div
      className={[
        css.spinner,
        sizeClass,
        colour === "dark" ? css.colourDark : css.colourLight
      ].join(" ")}
      role="status"
      style={style}
    >
      <span className="sr-only">Loading...</span>
    </div>
  );
};

LoadingIndicator.propTypes = {
  colour: PropTypes.oneOf(["light", "dark"]),
  size: PropTypes.oneOf(["small", "large"]),
  style: PropTypes.any
};

LoadingIndicator.defaultProps = {
  colour: "light",
  size: "small",
  style: {}
};

export default LoadingIndicator;
